"use client"

import { useAuth } from "./auth-context"
import { useRouter } from "next/navigation"
import { useSession, signOut } from "next-auth/react" 
import { ReactNode, useEffect } from "react"

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth()
  const { data: session, status } = useSession() 
  const router = useRouter()

  useEffect(() => {
    // 1. If NextAuth explicitly flags the Django token as dead, kill the session
    if (session?.error === "RefreshDjangoTokenError") {
      signOut({ callbackUrl: "/login" })
      return
    }

    // 2. If the auth context is fully loaded and they aren't authenticated, punt them
    if (status !== "loading" && !isLoading && !isAuthenticated) {
      router.replace("/login")
    }
  }, [status, isLoading, isAuthenticated, router, session])

  if (status === "loading" || isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-gray-900 dark:border-gray-600 dark:border-t-gray-100" />
          <p className="text-sm text-gray-500">Loading...</p>
        </div>
      </div>
    )
  }

  return isAuthenticated ? <>{children}</> : null
}
